module.exports = __webpack_public_path__ + "static/media/expressionless -face.4e7b687a.svg";